<style>
.div-header {
  font-weight: bold;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Dispositivos Vinculados</b-card-header>
      <b-card-body>
        <div class="div-header">Los siguientes dispositivos se encuentran asociados a tu cuenta.</div>
        <div
          class="div-header"
        >Si no reconcoces alguno de ellos, te recomendamos desvincularlo, para evitar posibles fraudes.</div>
        <div class="text-right" style="margin-bottom:20px; margin-top:20px">
          <button
            type="button"
            @click="UnLinkAllLoginDeviceAccount()"
            class="btn btn-primary"
            style="border-bottom:10px;background-color:red"
          >Desvincular Todos</button>
        </div>
        <div
          class="row"
          v-for="item in Model.Dispositivos"
          v-bind:key="item.DeviceID"
          style="padding-bottom: 15px; padding-top: 15px; border-bottom: 1px solid #d6d4d4; cursor: pointer"
        >
          <div class="col-md-8">{{item.Model}}</div>
          <div class="col-md-2">{{item.FormattedLinkDateTime}}</div>
          <button
            type="button"
            @click="UnLinkLoginDeviceAccount(item.EntityID)"
            class="btn btn-primary"
            style="border-bottom:10px;background-color:red"
          >Desvincular</button>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
export default {
  data() {
    return {
      Model: { Dispositivos: [] }
    };
  },
  methods: {
    GetAllLoginDeviceAccountByAccount() {
      let context = this;

      axiosHelpers.axiosGet(
        "LinkedDevices/GetAllLoginDeviceAccountByAccount",
        {},
        context,
        function(data) {
          context.Model.Dispositivos = data.ResponseVM.Items;
        }
      );
    },
    UnLinkLoginDeviceAccount(Id) {
      let context = this;
      axiosHelpers.axiosPost(
        "LinkedDevices/UnLinkLoginDeviceAccount",
        { LoginDeviceAccountID: Id },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            context.GetAllLoginDeviceAccountByAccount();
          }
        }
      );
    },
    UnLinkAllLoginDeviceAccount() {
      let context = this;
      axiosHelpers.axiosPost(
        "LinkedDevices/UnLinkAllLoginDeviceAccount",
        {},
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            context.GetAllLoginDeviceAccountByAccount();
          }
        }
      );
    }
  },
  beforeMount() {
    this.GetAllLoginDeviceAccountByAccount();
  }
};
</script>